import { render, staticRenderFns } from "./supercargo.vue?vue&type=template&id=666a4020&scoped=true&"
import script from "./supercargo.vue?vue&type=script&lang=js&"
export * from "./supercargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666a4020",
  null
  
)

export default component.exports